import { validateEmail } from '@adaptiva/core/common';
import { ErrorHandlerService } from '@adaptiva/core/error-handler';
import { LoggingService } from '@adaptiva/core/logging';
import { BaseActionOverlay, BeforeSubmitFn, OverlayService } from '@adaptiva/core/overlays';
import { SnackbarService } from '@adaptiva/core/snackbars';
import { UiService } from '@adaptiva/core/ui';
import { AuthenticationService } from '@adaptiva/data-service';
import { InputComponent } from '@adaptiva/widgets/input';
import { ChangeDetectionStrategy, Component, Signal, viewChild } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Component({
	standalone: false,
	selector: 'ada-forgot-password-overlay',
	templateUrl: './forgot-password-overlay.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordOverlayComponent extends BaseActionOverlay<string> {

	public readonly errorMessage: BehaviorSubject<string> = new BehaviorSubject('');

	public override ready: BehaviorSubject<boolean> = new BehaviorSubject(true);

	public readonly emailInput: Signal<InputComponent> = viewChild(InputComponent);

	constructor(
		protected auth: AuthenticationService,
		protected snackbarService: SnackbarService,
		protected errorHandler: ErrorHandlerService,
		_overlayService: OverlayService,
		_ui: UiService,
		_logger: LoggingService
	) {
		super(_overlayService, _ui, _logger, {
			title: 'Forgot Password',
			confirmText: 'Request Reset'
		});
	}

	public override beforeSubmit: BeforeSubmitFn = (): boolean | Observable<boolean> => {
		if (!this.context) {
			this.errorMessage.next('Please supply an email address');

			return false;
		}

		if (!validateEmail(this.context)) {
			this.errorMessage.next('Invalid email address');

			return false;
		}

		return this.auth.requestResetPassword(this.context.trim()).pipe(
			map(() => {
				this.snackbarService.display('Successfully requested password reset');
				this.errorMessage.next('');

				return true;
			}),
			catchError((e: Error) => {
				this.errorHandler.defaultErrorHandler(e, 'ForgotPasswordOverlayComponent.beforeSubmit');
				this.errorMessage.next(this.logger.extractErrorMessage(e));

				return of(false);
			})
		);
	};

	protected applyContext(_context: string): void {
		return;
	}

}
